import { languages } from 'monaco-editor/esm/vs/editor/editor.api';

const keywordRegex = /\s*[\w]+(?=:)/;

export const granetSyntaxMeta = {
    keywords: ['root', 'slots', 'filler'],
    builtinEntities: ['YANDEX.NUMBER', 'YANDEX.FIO', 'YANDEX.DATETIME', 'YANDEX.GEO'],
    directives: ['%lemma', '%exact'],
    alphabetical: /а-яА-Яё\w/,
    separator: /[^а-яА-Яё\w]|$/,
    operators: /[+?*|\[\]()]/,
};

// https://microsoft.github.io/monaco-editor/monarch.html
const granetSyntaxConfig: languages.IMonarchLanguage = {
    tokenizer: {
        root: [
            {
                regex: /^entity\s+/,
                action: {
                    token: 'keyword',
                    next: '@entityDecl',
                },
            },
            {
                regex: keywordRegex,
                action: {
                    cases: {
                        '@keywords': 'keyword',
                        '@default': 'keyword',
                    },
                },
            },
            {
                regex: /\s*\$([\w.]+)(?=@separator)/,
                action: {
                    cases: {
                        // 1-st capture group is one of the builtinEntities
                        '$1@builtinEntities': 'keyword',
                        '@default': 'type',
                    },
                },
            },
            {
                regex: /^[^#]+(?=:)/,
                action: 'invalid',
            },
            {
                regex: /%[\w]+(?=@separator)/,
                action: {
                    cases: {
                        '@directives': 'tag',
                        '@default': 'invalid',
                    },
                },
            },
            {
                regex: /@operators/,
                action: 'tag',
            },
            {
                regex: /\s+#.*$/,
                action: 'comment',
            },
            {
                regex: /^#.*$/,
                action: 'comment',
            },
            {
                regex: /"/,
                action: {
                    token: 'string.quote',
                    bracket: '@open',
                    next: '@string',
                },
            },
        ],

        string: [
            {
                regex: /([^"\\]|\\.)*$/,
                action: {
                    token: 'invalid',
                    next: '@pop',
                },
            },
            {
                regex: /[^\\"]+/,
                action: 'string',
            },
            {
                regex: /\\./,
                action: 'string',
            },
            {
                regex: /"/,
                action: {
                    token: 'string.quote',
                    bracket: '@close',
                    next: '@pop',
                },
            },
        ],

        entityDecl: [
            {
                regex: /\w*[^@alphabetical]+\w*(?=@separator)/,
                action: {
                    token: 'invalid',
                },
            },
            {
                regex: /[\w]+(?=:)/,
                action: {
                    token: 'type',
                },
            },
            {
                regex: /:(?=\s|$)/,
                action: {
                    // predefined token in monarch. No relation to granet entities
                    token: 'entity',
                    next: '@pop',
                },
            },
        ],
    },
};

export const granetSyntaxDefinition = {
    // split for proper typings
    ...granetSyntaxMeta,
    ...granetSyntaxConfig,
};
